export { default as MenuTabla } from './MenuTabla';
export { default as TablaDeDeudores } from './TablaDeDeudores';



// WEBPACK FOOTER //
// ./src/modulos/Cobranzas/componentes/Deudores/componentes/index.ts